import React, { useEffect, useMemo, useState } from 'react'
import { MwButton, MwInputText, MwSelector, MwSpinnerButton } from '../ui'
import { useFetch } from '../../hooks'
import { useTranslation } from 'react-i18next';

const CreatePaymentMethod = ({
    currentLangList,
    currentTenantId,
    currentCompanyId,
    currentBranchId,
    currentLangId,
    userId,
    data,
    postData,
    loading,
    apiBaseUrl,
    showTreasury = false,
    financeApiBaseUrl
}) => {
    const createdBy = userId || (() => {
        try {
            return JSON.parse(localStorage.getItem('user'))?._id || ''
        } catch {
            return ''
        }
    })();
    const [namepaymentMethod, setNamepaymentMethod] = useState({});
    const [despaymentMethod, setDescpaymentMethod] = useState({});
    const [treasurySelected, setTreasurySelected] = useState('');
    const [treasuriesList, setTreasuriesList] = useState([]);
    const [t] = useTranslation('global');
    const [tabLang, setTabLang] = useState('en');
    const financeBaseUrl = useMemo(() => {
        if (financeApiBaseUrl) {
            return financeApiBaseUrl.replace(/\/+$/, '');
        }
        if (process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL) {
            return process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL.replace(/\/+$/, '');
        }
        return `${(process.env.REACT_APP_API_URL || '').replace(/\/+$/, '')}/finance`;
    }, [financeApiBaseUrl]);
    const { data: treasuriesResult } = useFetch(
        showTreasury
            ? `${financeBaseUrl}/treasuries/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
            : null
    );

    const submitHandler = (e) => {
        e.preventDefault();
        if (Object.keys(namepaymentMethod).length === 0 && Object.keys(despaymentMethod).length === 0) return;
        let description = [];

        currentLangList.map((lang) => {
            if (!namepaymentMethod[lang.langCode] && !despaymentMethod[lang.langCode]) return;
            description = [...description, {
                name: namepaymentMethod[lang.langCode],
                desc: despaymentMethod[lang.langCode],
                lang: lang.langCode
            }];
        });
        const _data = {
            isActive: true,
            tenantId: currentTenantId,
            companyId: currentCompanyId,
            branchId: currentBranchId,
            createdBy,
            treasurie_id: showTreasury ? treasurySelected?.value || '' : '',
            description: description
        };
        const baseUrl = (apiBaseUrl || process.env.REACT_APP_INV_API_SERVER_BASE_URL || "").replace(/\/+$/, "");
        const url = baseUrl ? `${baseUrl}/payment-methods` : "";
        postData(url, _data);
    };

    useEffect(() => {
        if (!!data && !loading) {
            setNamepaymentMethod({});
            setDescpaymentMethod({});
            setTreasurySelected('');
        }
    }, [data, loading]);

    useEffect(() => {
        if (!showTreasury || !treasuriesResult?.data) return;
        const list = treasuriesResult.data.map((item) => ({
            label: currentLangId === 'ar' ? item.name_ar : item.name_en,
            value: item.id,
            lang: currentLangId,
        }));
        setTreasuriesList(list);
    }, [showTreasury, treasuriesResult, currentLangId]);

    return (
        <div>
            <div className='text-sm text-slate-500 pb-3'>{t('settings.paymentMethodSettings')}</div>
            <div className='p-3 rounded-lg border border-slate-200'>
                <form onSubmit={submitHandler}>
                    <div className='flex justify-between items-center'>
                        <div className='text-xs py-2 text-slate-500'></div>
                        {loading ? <MwSpinnerButton /> : <MwButton
                            inGroup={true}
                            size='sm'
                            type='saveBtn'>{t("setting.Save_changes")}
                        </MwButton>}
                    </div>
                    <div className='flex flex-col gap-3 py-2 md:flex-row md:gap-0'>
                        {currentLangList.map(lang => {
                            return (
                                <div key={lang._id} className={`flex flex-col gap-2 flex-1 ${tabLang === lang.langCode ? 'block' : 'hidden'}`}>
                                    <div className="flex justify-between items-center mb-2">
                                        <button
                                            onClick={(e) => {
                                                e.preventDefault();
                                                const currentIndex = currentLangList.findIndex((l) => l.langCode === tabLang);
                                                const nextIndex = (currentIndex + 1) % currentLangList.length;
                                                setTabLang(currentLangList[nextIndex].langCode);
                                            }}
                                            type="button"
                                            className="px-2 py-0.5 text-xs bg-blue-500 text-white rounded hover:bg-blue-600"
                                        >
                                            {tabLang === 'ar' ? 'EN' : 'AR'}
                                        </button>
                                        <span className='text-xs text-slate-500'>
                                            {lang.langCode === 'en' ? 'Payment Method In English' : ' طريقة الدفع بالعربي'}
                                        </span>
                                    </div>
                                    <MwInputText
                                        placeholder={lang.langCode === 'en' ? 'Enter payment method name' : 'ادخل طريقة الدفع'}
                                        size='sm'
                                        value={namepaymentMethod[lang.langCode] || ''}
                                        onChange={(e) => setNamepaymentMethod({ ...namepaymentMethod, [lang.langCode]: e.target.value })}
                                    />
                                    <MwInputText
                                        placeholder={lang.langCode === 'en' ? 'Enter payment method description' : 'ادخل وصف لطريقة الدفع'}
                                        size='sm'
                                        value={despaymentMethod[lang.langCode] || ''}
                                        onChange={(e) => setDescpaymentMethod({ ...despaymentMethod, [lang.langCode]: e.target.value })}
                                    />
                                    {showTreasury && (
                                        <MwSelector
                                            label={t('invoice.Treasury')}
                                            initalValue={t('invoice.selectTreasury')}
                                            dataType='labelValue'
                                            _data={treasuriesList}
                                            withAddNew={false}
                                            withSearch={true}
                                            selectedItem={treasurySelected}
                                            setSelectedItem={setTreasurySelected}
                                        />
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </form>
            </div>
        </div>
    );
}

export default CreatePaymentMethod
